import { useCallback, useMemo } from "react";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";

export function useBookGrouping() {
  const { isMultiBook, books } = useBiCommonDataContext();

  const booksByCode = useMemo(() => Object.fromEntries(books.map((b) => [b.code, b.name])), [books]);

  const groupByBook = useCallback(
    <T>(items: T[], getCode: (item: T) => string | null | undefined): Record<string, T[]> => {
      const groups: Record<string, T[]> = {};
      for (const item of items) {
        const code = getCode(item) ?? null;
        const title = (code ? booksByCode[code] : null) ?? "Memo";
        (groups[title] ??= []).push(item);
      }
      return groups;
    },
    [booksByCode]
  );

  return { isMultiBook, groupByBook };
}
